import { connect } from 'dva';

const LabTerminal = ({ routerModel: { matchParams } }) => {
  return matchParams.webTermLink ? (
    <iframe
      title={window.name}
      src={matchParams.webTermLink}
    />
  ) : null;
};

export default connect(({ routerModel }) => ({ routerModel }))(LabTerminal);
